// Modules
import React from "react";
//@ts-ignore
 import {LocalizationContext} from "react-localize";

// Styles
import "./StayPreferences.sass";

// Components
import { PreferencesModal } from "./PreferencesModal";

// Interfaces
import { Preferences } from "Interfaces/AYPResultInterface";
import { SelectedPreferences } from "./Review/Review";

type Props = {
  preferenceOptions: Preferences;
  selectedPreferences: SelectedPreferences;
  optionsLoading: boolean;
  updateStayPreferences: (prefs: SelectedPreferences) => void;
  readOnly: boolean;
};

type StayPreferenceState = {
  showPreferencesModal: boolean;
}

const InitState: StayPreferenceState = {
  showPreferencesModal: false,
};

class StayPreferences extends React.Component<Props, StayPreferenceState> {
  constructor(props: Readonly<Props>) {
    super(props);
    this.state = Object.assign({}, InitState);
  }
  
  getPreferencesString = () => {
    const {localize} = this.context;
    let preferencesString: string[] = [];

    const roomRequests = this.props.selectedPreferences.roomRequests;

    // Check for selected preferences
    Object.keys(roomRequests).map(prefCode => {
      const pref = this.props.preferenceOptions.find(preferenceOption => preferenceOption.code === prefCode);
      if (!pref) return;

      if (pref && pref.multiselect) {
          const selectedPrefs = pref.options.filter(option => {
            return (roomRequests[prefCode] as string[]).indexOf(option.code) !== -1;
          });
          preferencesString.push(...selectedPrefs.map(selectedPref => selectedPref.name))
      } else {
        const selectedPref = pref.options.find(option => option.code === roomRequests[prefCode]);
        if (!selectedPref || selectedPref.name === 'No Preference') return;
        preferencesString.push(selectedPref.name as string)
      }
    });

    // If no preferences have been selected
    if (!preferencesString.length) {
      preferencesString = this.props.readOnly ? [localize("None")] : [localize("static.content.sr-special-requests")];
    }

    return preferencesString.join(", ");
  }

  togglePreferencesModal = (show: boolean) => {
    this.setState({showPreferencesModal: show});
  }

  render() {
    const {localize} = this.context;

    const hasRoomSelections = Object.keys(this.props.selectedPreferences.roomRequests).some(prefCode => {
      const roomPrefSelection = this.props.selectedPreferences.roomRequests[prefCode];

      // selection could be an array of selections or a string (id of selection)
      // if it's an array, check if array is empty
      // if it's not an array, it will be a string, check if it's not '-1' for no preference
      if (Array.isArray(roomPrefSelection)) {
        return roomPrefSelection.length > 0;
      }

      return roomPrefSelection as string !== '-1';
    })

    const hasAdditionalRequests = this.props.selectedPreferences.additionalRequests.length > 0;

    const preferencesAdded: boolean = (
      hasRoomSelections ||
      hasAdditionalRequests
    );

    const requestButtonText = (
      preferencesAdded ? 
        localize("Edit Request")
        : localize("static.content.sr-make-req")
      )

    const additionalRequests = this.props.selectedPreferences.additionalRequests;
    const readOnly = this.props.readOnly;

    return (
      <div className="stay-preferences-container">
        <PreferencesModal
            show={this.state.showPreferencesModal}
            toggle={this.togglePreferencesModal}
            preferenceOptions={this.props.preferenceOptions}
            onUpdate={this.props.updateStayPreferences}
            optionsLoading={this.props.optionsLoading}
            selectedPreferences={this.props.selectedPreferences}
        />
        <div className='inner-container'>
          <div>
            <div className='preference-header'>
               {localize("static.content.sr-stay-preference-header")}
            </div>
              {this.getPreferencesString()}
          </div>
          <div className='list-item'>{localize("static.content.sr-sp-req")}
            <div className='list-content'>{additionalRequests ? additionalRequests : localize("static.content.sr-additional-requests")}
            </div>
          </div>
          <button
            className={"mv-button primary" + (readOnly ? " hide-button" : "")}
            onClick={() => this.togglePreferencesModal(true)}
          >
            {requestButtonText}
          </button>
        </div>
      </div>
    );
  }
}

StayPreferences.contextType = LocalizationContext;

export default StayPreferences;
